import { shipmentZonesStore } from './shipmentZonesStore' 
import { subscriptionStore } from './subscriptionStore' 
import { deliveryStore } from './deliveryStore' 
import { orderStore } from './orderStore' 

export const stepStore = {
	state: {
		updating: {
			subscription: false
		},

		loading: {
			subscription: false
		}	
	},

	stepSubscription () {
		if (shipmentZonesStore.state.shipmentZones.available.length <= 0) {
			return Promise.reject(Error('Consegne non disponibile'))
		}

		var req = {
			subscription: [
				{'name': 'name', 'label': 'name'},
				{'name': 'street', 'label': 'street'},
				{'name': 'zip_code', 'label': 'zip_code'},
				{'name': 'city', 'label': 'city'},
				{'name': 'telephone', 'label': 'telephone'},
        {'name': 'latitude', 'label': 'street'},
        {'name': 'longitude', 'label': 'street'}
			]
		}

		// control only if passing param exists (e.g. not to control in case of payback card update)
		if (req.subscription.find(field => !subscriptionStore.state.subscriptionParams[field.name])) {
      var response = new Error('Missing ' + req.subscription.find(field => {
        return !subscriptionStore.state.subscriptionParams[field.name]
      }).label)
      return Promise.reject(response)
    }

    this.state.updating.subscription = true   

    return this.updateShipmentZone().then(i => {
    	return orderStore.updateOrder()
  	})
	},

	updateShipmentZone () {
		this.state.loading.subscription = true

		return this.updateOrCreateResource({
			resource_type: 'delivery',
			target_type: 'order',
			target_id: +orderStore.state.order.id
		})

		.then(response => {
			if (!orderStore.state.order) return Promise.resolve()

			return deliveryStore.getDelivery({ 
	        	target_type: 'order', 
	        	target_id: +orderStore.state.order.id 
	    	}) 
		})

		.then(response => {
			let del = deliveryStore.state.deliveries.order.find(r => r.attributes.target_id === +orderStore.state.order.id)
			if (!del) return Promise.resolve()

			return this.updateOrCreateResource({
				resource_type: 'time-range',
				target_type: 'delivery',
				target_id: +del.id
			})
		})

		.then(response => {
			this.state.loading.subscription = false
		})

		.catch(response => {
			this.state.loading.subscription = false
		})
	},

	targetAndIdFilter (params) { 
    	return function (r) { 
	    	const targetFilter = (r) => r.attributes.target_type === params.target_type 
	    	const idFilter = (r) => +r.attributes.target_id === params.target_id 
	    	return targetFilter(r) && idFilter(r) 
	    } 
    }, 

    deleteResource (vars) {
		if (vars.target_type === 'subscription' || vars.target_type === 'order') {
			return deliveryStore.deleteDelivery(vars)
		}

		if (vars.target_type === 'delivery') {
			return deliveryStore.deleteTimeRanges(vars)
		}
	},

	createResource (vars) {
		if (vars.target_type === 'subscription' || vars.target_type === 'order') {
			return deliveryStore.createDelivery(vars)
		}

		if (vars.target_type === 'delivery') {
			return deliveryStore.createTimeRanges(vars)
		}
	},

	updateResource (vars) {
		if (vars.target_type === 'subscription' || vars.target_type === 'order') {
			return deliveryStore.updateDelivery(vars)
		}

		if (vars.target_type === 'delivery') {
			return deliveryStore.updateTimeRanges(vars)
		}
	},

	updateOrCreateResource (params) {
		if (params.resource_type === 'delivery') {
			var resource = deliveryStore.state.deliveries[params.target_type]
		}

		if (params.resource_type === 'time-range') {
			var resource = deliveryStore.state.timeRanges[params.target_type]
		}

		var resourceFilteredByTarget = resource.filter(this.targetAndIdFilter({ 
	    	target_type: params.target_type, 
	    	target_id: params.target_id 
	    })) 


		if (resourceFilteredByTarget.length === 1) {
			return this.updateResource({
				resource_type: params.resource_type,
				target_type: params.target_type,
				target_id: params.target_id
			})
		} 

		if (resourceFilteredByTarget.length > 1) {
			var targetArray = resource.map(r => r.id)
			var targetQuery = targetArray.slice(1).join(',')

				return this.deleteResource({
					resource_type: params.resource_type,
					target_type: params.target_type,
					params: {
						query: 'id in (' + targetQuery + ')'
					}
				})

			.then(response => {
				return this.updateResource({
					resource_type: params.resource_type,
					target_type: params.target_type,
					target_id: params.target_id
				})
			})
		}

		if (resourceFilteredByTarget.length <= 0) {
			return this.createResource({
				resource_type: params.resource_type,
				target_type: params.target_type,
				target_id: params.target_id
			})
		}
	}
}